import React from 'react'
import { Widget, Action, mk_widget } from 'widgets-for-react'
import { HeaderState, OptionsState } from '../../public_site.main.mod'
import NavItems from './nav_items'
import { SearchBar } from './searchbar'
import { Link } from 'react-router-dom'
import { gtmPush, toRelativeUrl } from '../../../helpers'

export const header: (_: HeaderState, o: OptionsState) => Widget<Action<HeaderState>> = (
  props,
  opts
) =>
  mk_widget({
    run: o => {
      return (
        <>
          <Header
            mobileMenu={props.menu}
            onMouseLeave={_ => o(s => ({ ...s, hoveredItem: null }))}
          >
            <div className='header__inner container container--l'>
              <div className='header__logo-wrap'>
                <Link to={'/'} className='header__logo-link'>
                  <span className='sr-text'>Logo</span>
                  <svg className='header__logo' width='240px' height='56px' aria-hidden="true">
                    <use xlinkHref='#icon--logo' />
                  </svg>
                </Link>
              </div>
              <nav className='nav nav--main'>
                <div className='nav__inner'>
                  <NavItems cssClass='nav__list'
                    location='main'
                    hasActiveState={true}
                    hoveredItem={props.hoveredItem}
                    onHoverItem={item => o(s => ({ ...s, hoveredItem: item }))}
                    onUnhoverItem={() => o(s => ({ ...s, hoveredItem: null }))}
                  />
                </div>
                <div className='nav__actions'>
                  <button
                    className='nav__search'
                    onClick={_ => {
                      gtmPush({ category: 'Search', action: 'open' })
                      o(s => ({
                        ...s,
                        showSearchBar: !props.showSearchBar
                      }))

                      !props.showSearchBar
                        ? document.body.classList.add('noscroll')
                        : document.body.classList.remove('noscroll')
                    }}
                  >
                    <span className='sr-text'>Show searchbar</span>
                    <svg
                      className='nav__search-icon'
                      width='18px'
                      height='18px'
                      aria-hidden="true"
                    >
                      <use xlinkHref='#icon--search' />
                    </svg>
                  </button>
                  {/* hamburger menu */}
                  <button
                    className='nav__toggle'
                    onClick={_ => {
                      if (props.menu == 'open') {
                        o(s => ({
                          ...s,
                          menu: 'closed'
                        }))
                      } else if (props.menu == 'closed') {
                        o(s => ({
                          ...s,
                          menu: 'open'
                        }))
                      }
                    }}
                  >
                    <span className='sr-text'>Toggle Menu</span>
                    <div className='nav__hamburger'>
                      <span />
                      <span />
                      <span />
                    </div>
                  </button>
                  <a className="nav__login nav__login--desktop btn btn--primary" href="/mijn-hypotrust" target="_blank">
                    Mijn Hypotrust
                  </a>
                </div>
              </nav>
            </div>
            {/*secondary Menu that shows on hover */}
            {/*secondary menu html is in dotnet/Client/styleguide/components/components.tsx. Look for "Secondary Navigation" */}
            {
              props.hoveredItem && props.hoveredItem.children && props.hoveredItem.children.length > 0 && <div onMouseLeave={() => o(s => ({ ...s, hoveredItem: null }))} className="header__flyout flyout flyout--open">
                <div className="flyout__inner container container--s grid--gutter">
                  <nav className="nav nav--submenu">
                    <ul className="nav__list list--chevron">
                      {props.hoveredItem.children.map((menuChild => <li className="nav__item list__item" key={`menu-child-${menuChild.ID}`}>
                        <Link className="nav__link list__link" to={toRelativeUrl(menuChild.url)}>
                          <svg
                            className="nav__icon list__icon"
                            width="8px"
                            height="5px"
                          >
                            <use xlinkHref="#icon--chevron" />
                          </svg>
                          <span>{menuChild.title}</span>
                        </Link>
                      </li>))}
                    </ul>
                  </nav>
                </div>
              </div>
            }
          </Header>

          <SearchBar
            show={props.showSearchBar}
            hide={() => {
              o(s => ({ ...s, showSearchBar: false }))
            }}
            searchValue={props.searchValue}
            updateSearchValue={newValue => o(s => ({ ...s, searchValue: newValue }))}
          />
        </>
      )
    }
  })

type HeaderComponentState = {
  sticky: boolean
  shown: boolean
}

type HeaderComponentProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  mobileMenu: 'open' | 'closed'
}

class Header extends React.Component<HeaderComponentProps, HeaderComponentState> {
  private raf: number
  private headerRef: HTMLElement
  private headerHeight: number = 0
  private scrollStartTime: number = 0
  private scrollStartY: number = 0

  constructor(props) {
    super(props)

    this.state = {
      sticky: false,
      shown: false
    };

    this.updateScrollState = this.updateScrollState.bind(this)
    this.raf = window.requestAnimationFrame(this.updateScrollState)
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(this.raf)
  }

  updateScrollState(t: number) {
    this.raf = window.requestAnimationFrame(this.updateScrollState)
    this.headerHeight = this.headerRef.clientHeight

    if (window.pageYOffset < (this.headerHeight / 2)) {
      this.setState({
        ...this.state,
        sticky: false,
        shown: true
      })
      return
    }

    if (
      this.scrollStartTime > 0 &&
      t - this.scrollStartTime < 100 &&
      this.scrollStartY - window.pageYOffset > 10
    ) {
      this.setState({
        ...this.state,
        shown: true
      })
      return
    } else if (
      this.scrollStartY - window.pageYOffset < 0 &&
      this.props.mobileMenu != "open"
    ) {
      this.setState({
        ...this.state,
        shown: false
      })
    }

    this.scrollStartY = window.pageYOffset
    this.scrollStartTime = t

    if (window.pageYOffset > this.headerHeight) {
      if (!this.state.sticky) {
        this.setState({
          ...this.state,
          sticky: true
        })
      }
    } else {
      this.setState({
        ...this.state,
        sticky: false
      })
    }
  }

  render() {
    return (
      <header
        ref={ref => (this.headerRef = ref)}
        className={`header header--main${this.state.sticky ? " header--stuck" : ""
          }${this.state.shown ? " header--shown" : ""}${this.props.mobileMenu == "open" ? " header--full-menu" : ""
          }`}
      >
        {this.props.children}
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/header.mod.tsx